import { Link, createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { ProfileSettings } from "../features/settings/ProfileSettings";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/settings/profile")({
  component: ProfilePage,
});

function ProfilePage() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return (
    <>
      <h2>{t("settings.profile.title")}</h2>
      <ProfileSettings key={me.data.user.id} me={me.data} />
      {/* Deletion lives on the Privacy tab; people look for it here first. */}
      <p className="mt-8 border-t pt-4 text-sm">
        <Link to="/app/settings/privacy" hash="delete-heading">
          {t("privacy.delete.title")}
        </Link>
      </p>
    </>
  );
}
